export const replaceURLParams = (text, keywordsMap) => {
	if (!text) return text;

	Object.keys(keywordsMap).forEach(keyword => {
		text = text.replace(`:${ keyword }`, keywordsMap[keyword] + "")
	});

	return text;
};
